import createVueComponent from '../createVueComponent';

const Table = createVueComponent('TableIcon', [
  ['path', { d: 'M12 3v18', key: '108xh3' }],
  [
    'rect',
    { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' },
  ],
  ['path', { d: 'M3 9h18', key: '1pudct' }],
  ['path', { d: 'M3 15h18', key: '5xshup' }],
]);

export default Table;
